import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLoader } from '@fortawesome/pro-solid-svg-icons/faLoader';
import type { FC } from 'react';
import React, { memo } from 'react';

import classnames from 'classnames';

import style from './loading-indicator.module.less';

type LoadingIndicatorType = {
  className?: string;
  theme?: 'white' | 'grey';
  'data-testid'?: string;
  iconClassName?: string;
  iconTitle?: string;
};

export const LoadingIndicator: FC<LoadingIndicatorType> = memo(
  ({ className = '', theme = 'grey', 'data-testid': testId, iconClassName, iconTitle = 'spinner' }) => {
    return (
      <div className={classnames(className, style['loading-indicator'], style[theme])} data-testid={testId}>
        <div className={style['icon-wrapper']}>
          <FontAwesomeIcon aria-hidden={false} aria-label={iconTitle} className={classnames(style.icon, iconClassName)} icon={faLoader} />
        </div>
      </div>
    );
  },
);
